// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
.icon-circle {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px;
  min-height: 40px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
  flex-shrink: 0;
}

.icon-circle i {
  font-size: 18px !important;
  line-height: 1 !important;
}

.card-hover {
  transition: all 0.3s ease;
  border-radius: 12px !important;
}

.card-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.nav-tabs-custom .nav-item .nav-link.active {
  color: #4b38b3 !important;
  border-bottom: 2px solid #4b38b3 !important;
  background: transparent !important;
}

.nav-tabs-custom .nav-item .nav-link {
  border: none !important;
  border-bottom: 2px solid transparent !important;
  background: transparent !important;
}

.nav-tabs-custom .nav-item .nav-link:hover {
  border-bottom: 2px solid #dee2e6 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Client/css/ClientDetail.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;EAC/C,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;AAC7C","sourcesContent":["/* styles.css */\n.icon-circle {\n  width: 40px !important;\n  height: 40px !important;\n  min-width: 40px;\n  min-height: 40px;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border-radius: 50% !important;\n  flex-shrink: 0;\n}\n\n.icon-circle i {\n  font-size: 18px !important;\n  line-height: 1 !important;\n}\n\n.card-hover {\n  transition: all 0.3s ease;\n  border-radius: 12px !important;\n}\n\n.card-hover:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;\n}\n\n.nav-tabs-custom .nav-item .nav-link.active {\n  color: #4b38b3 !important;\n  border-bottom: 2px solid #4b38b3 !important;\n  background: transparent !important;\n}\n\n.nav-tabs-custom .nav-item .nav-link {\n  border: none !important;\n  border-bottom: 2px solid transparent !important;\n  background: transparent !important;\n}\n\n.nav-tabs-custom .nav-item .nav-link:hover {\n  border-bottom: 2px solid #dee2e6 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
